export const PLAN_TIERS = Object.freeze({
  FREE: 'free',
  PRO: 'pro',
  CREATOR: 'creator',
  ENTERPRISE: 'enterprise'
});

export const PLAN_PERIODS = Object.freeze({
  MONTHLY: 'monthly',
  ANNUAL: 'annual'
});

export const PLAN_ONBOARDING_STATES = Object.freeze({
  COMPLETED: 'completed',
  PENDING_ORG_SETUP: 'pending_org_setup',
  PENDING_ACTIVATION_CODE: 'pending_activation_code',
  PENDING_SIGNUP_PROFILE: 'pending_signup_profile',
});

export const PLAN_TIER_LABELS = Object.freeze({
  free: 'Free',
  pro: 'Learner+',
  creator: 'Creator',
  enterprise: 'Enterprise',
});

export function normalizePlanTier(value) {
  const tier = String(value || '').trim().toLowerCase();
  if (Object.values(PLAN_TIERS).includes(tier)) return tier;
  return null;
}

export function needsMandatoryOrgSetup(tier) {
  return tier === PLAN_TIERS.CREATOR || tier === PLAN_TIERS.ENTERPRISE;
}

export function formatPlanTierLabel(value, fallback = 'Free') {
  const tier = normalizePlanTier(value);
  if (!tier) return fallback;
  return PLAN_TIER_LABELS[tier] || fallback;
}
